export function roundRect(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

/**
 * Loads an image for canvas compositing. Cross-origin sources are fetched into a blob first —
 * drawing an <img> straight from a cross-origin src taints the canvas and blocks toDataURL().
 */
export async function loadImage(src: string): Promise<HTMLImageElement> {
  const objectUrl = src.startsWith('data:') ? null : URL.createObjectURL(await (await fetch(src)).blob());
  try {
    return await new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = objectUrl ?? src;
    });
  } finally {
    if (objectUrl) URL.revokeObjectURL(objectUrl);
  }
}
